module.exports = __webpack_public_path__ + "static/img/hypnose-thumb.c9cc068.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-thumb.jpg
// module id = 34
// module chunks = 0